
import { getGiveawayActions } from 'Helpers/Product/persisted-giveaway-actions';

export const GET_GIVEAWAY_ACTIONS = 'frontend/giveaway/GET_GIVEAWAY_ACTIONS';
export const SET_GIVEAWAY_ACTIONS = 'frontend/giveaway/SET_GIVEAWAY_ACTIONS';

const initialState = getGiveawayActions();

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_GIVEAWAY_ACTIONS:
      return initialState;
    case SET_GIVEAWAY_ACTIONS:
      return action.payload;
    default:
      return state;
  }
}
